import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import { useLogoDestination } from './useLogoDestination';

interface UseInAppBack {
    routerBack(): void;
}

export const useInAppBack = ({ router }: Pick<ReturnType<typeof useVueRouter>, 'router'> = useVueRouter()): UseInAppBack => {
    const logoDestination = useLogoDestination();

    const routerBack = () => {
        // Without this check the web will go to a previous domain, and we don't want the in-app back to leave the app
        if (!window.history.state || window.history.state.hasLandedOnThisRoute) {
            router.value.push({
                name: logoDestination.value?.location.name,
            });
        } else {
            router.value.back();
        }
    };

    return {
        routerBack,
    };
};
